import React from 'react';

import Webcam from './Webcam';

const WebcamCollection = () => {
  const { webcams } = drupalSettings;

  return (
    <div id="react-webcam-collection" className="webcam-collection">
      {webcams.map((webcam, i) => (
        <Webcam key={i} id={i}>
          {webcam}
        </Webcam>
      ))}
    </div>
  );
};

export default WebcamCollection;
